import React from 'react';
import './StaticPage.css';
import './UeberRefiReg.css';

const UeberRefiReg = ({onBack}) => {
    return (
        <div className="static-page">
            <div className="static-content">
                <div className="static-header">
                    <img
                        src={`${process.env.PUBLIC_URL}/main.png`}
                        alt="SRR Logo"
                        className="static-logo"
                    />
                </div>

                <div className="static-text-container">
                    <h1>Über RefiReg</h1>
                    Diese Seite bietet ein voll funktionsfähiges Testsystem, das die Funktionen des
                    Refinanzierungsregisters gemäß Kreditwesengesetz (§§&nbsp;22a–22o&nbsp;KWG) und
                    Refinanzierungsregisterverordnung (RefRegV) in der fiktiven Demo-Bank "OneBank"
                    demonstriert. Es ermöglicht Ihnen, die Registerführung in einer realistischen Umgebung
                    mit einer modernen, benutzerfreundlichen Benutzeroberfläche für Desktop und mobile Geräte
                    zu erleben und zu testen. <br/>
                    <div className="selectable-text">
                        <h2>Funktionen</h2>
                        <ul>
                            <li>Anlage der neuen Transaktionen mit Forderungen oder Sicherheiten</li>
                            <li>Übersicht der vorhandenen Transaktionen mit Filtermöglichkeiten</li>
                            <li>Detailansicht der einzelnen Transaktionen</li>
                            <li>Anpassung der vorhandenen Forderungen oder Sicherheiten (z.B. bei geänderten Sachlage)</li>
                            <li>
                                Import der Transaktionsdaten aus Fremd- oder Legacy-Systemen
                                via Schnittstellen (API) oder Benutzeroberfläche (UI)
                            </li>
                            <li>PDF-Export</li>
                            <li>Audit-Log für Änderungen und Aktionen</li>
                        </ul>

                        <h2>Möglichkeiten für Integration</h2>
                        <ul>
                            <li>
                                Integration mit führenden Bestandssystemen (z.B. SAP) zur einfacheren Eingabe von
                                bestehenden Daten.
                            </li>
                            <li>
                                Integration mit Refinanzierungssystemen zur Automatisierung der Refinanzierungsprozesse
                            </li>
                            <li>
                                Integration mit anderen relevanten Systemen über vorhandene REST-API möglich
                            </li>
                        </ul>

                        <h2>Sicherheit</h2>
                        <ul>
                            <li>
                                Authentifizierung und Autorisierung mittels moderner
                                Sicherheitsprotokolle OAuth2 und OpenID&nbsp;Connect
                            </li>
                            <li>
                                Unterstützung von LDAP und SAML über IAM-Systeme (z. B. Keycloak)
                            </li>
                        </ul>
                    </div>
                </div>

                <button
                    className="static-back-link"
                    onClick={onBack}
                >
                    Zurück
                </button>
            </div>
        </div>
    );
};

export default UeberRefiReg;

